import { render, staticRenderFns } from "./CardEdital.vue?vue&type=template&id=a8ea170c&scoped=true&lang=pug&"
import script from "./CardEdital.vue?vue&type=script&lang=js&"
export * from "./CardEdital.vue?vue&type=script&lang=js&"
import style0 from "./CardEdital.vue?vue&type=style&index=0&id=a8ea170c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ea170c",
  null
  
)

export default component.exports